/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MstUserInput
 */
export interface MstUserInput {
    /**
     * 
     * @type {number}
     * @memberof MstUserInput
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    companyHojinNo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    companyAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    companyGln?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    businessCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    tenantId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    userMail: string;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    authType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstUserInput
     */
    authTypeName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstUserInput
     */
    enabled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof MstUserInput
     */
    updateDatetime?: Date | null;
}

/**
 * Check if a given object implements the MstUserInput interface.
 */
export function instanceOfMstUserInput(value: object): value is MstUserInput {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userMail' in value) || value['userMail'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function MstUserInputFromJSON(json: any): MstUserInput {
    return MstUserInputFromJSONTyped(json, false);
}

export function MstUserInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstUserInput {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'companyName': json['company_name'] == null ? undefined : json['company_name'],
        'companyHojinNo': json['company_hojin_no'] == null ? undefined : json['company_hojin_no'],
        'companyAddress': json['company_address'] == null ? undefined : json['company_address'],
        'companyGln': json['company_gln'] == null ? undefined : json['company_gln'],
        'businessCategory': json['business_category'] == null ? undefined : json['business_category'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'userId': json['user_id'],
        'userMail': json['user_mail'],
        'userName': json['user_name'],
        'authType': json['auth_type'] == null ? undefined : json['auth_type'],
        'authTypeName': json['auth_type_name'] == null ? undefined : json['auth_type_name'],
        'enabled': json['enabled'],
        'updateDatetime': json['update_datetime'] == null ? undefined : (new Date(json['update_datetime'])),
    };
}

export function MstUserInputToJSON(json: any): MstUserInput {
    return MstUserInputToJSONTyped(json, false);
}

export function MstUserInputToJSONTyped(value?: MstUserInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'company_name': value['companyName'],
        'company_hojin_no': value['companyHojinNo'],
        'company_address': value['companyAddress'],
        'company_gln': value['companyGln'],
        'business_category': value['businessCategory'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
        'user_mail': value['userMail'],
        'user_name': value['userName'],
        'auth_type': value['authType'],
        'auth_type_name': value['authTypeName'],
        'enabled': value['enabled'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
    };
}

